import api from "@/services/api";

export default {
  createTransaction(payload) {
    return api
      .post("transactions/create_transaction/", payload)
      .then((response) => response.data);
  },
  enrollCard() {
    return api
      .post("transactions/enroll_card/")
      .then((response) => response.data);
  },
  unsubscribeCard() {
    return api
      .post("transactions/unsubscribe_card/")
      .then((response) => response.data);
  },
  getCardDetails() {
    return api
      .get("transactions/get_card_details/")
      .then((response) => response.data);
  },
  getProducts() {
    return api.get("business-product/").then((response) => response.data);
  },
  getLastTransaction() {
    return api
      .get("transactions/last_transaction/")
      .then((response) => response.data);
  },
  // Solo admin: el panel de "Uso de servicios".
  getAnalisis(params) {
    return api
      .get("transactions/analisis/", { params })
      .then((response) => response.data);
  },
  // Solo admin: reintenta el DTE de una compra cobrada sin folio.
  emitirDte(id) {
    return api
      .post(`transactions/${id}/emitir_dte/`)
      .then((response) => response.data);
  },
  // Solo admin: lo que el SII respondio sobre el DTE de una compra.
  getDteTrazas(id) {
    return api
      .get(`transactions/${id}/dte_trazas/`)
      .then((response) => response.data);
  },
};
